/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/share_android_medium'
export default icon
